// src/defer.ts
import { defer as rrDefer } from "react-router-dom";
var defer = rrDefer;

// src/loader.ts
import {
  useLoaderData as rrUseLoaderData,
  useRouteLoaderData as rrUseRouteLoaderData
} from "react-router-dom";
var useLoaderData = rrUseLoaderData;
var useRouteLoaderData = rrUseRouteLoaderData;

// src/action.ts
import { useActionData as rrUseActionData } from "react-router-dom";
var useActionData = rrUseActionData;

// src/utils.ts
var makeLoader = (loaderFn) => {
  return loaderFn;
};
var makeAction = (actionFn) => {
  return actionFn;
};

// src/components/Await.tsx
import { Await as RRAwait } from "react-router-dom";
var Await = RRAwait;

// src/browser-router.ts
import { createBrowserRouter } from "react-router-dom";
var joinValidWith = (separator) => (...valid) => valid.filter(Boolean).join(separator);
var typesafeBrowserRouter = (routes) => {
  function href(params) {
    var _a;
    const path = (params == null ? void 0 : params.params) ? Object.keys(params.params).reduce((path2, param) => {
      const value = params.params[param];
      if (typeof value !== "string")
        throw new Error(`Route param ${param} must be a string`);
      return path2.replace(`:${param}`, value);
    }, params.path) : params.path;
    const searchParams = new URLSearchParams(params == null ? void 0 : params.searchParams);
    const hash = (_a = params == null ? void 0 : params.hash) == null ? void 0 : _a.replace(/^#/, "");
    return joinValidWith("#")(joinValidWith("?")(path, searchParams.toString()), hash);
  }
  return {
    router: createBrowserRouter(routes),
    href
  };
};

// src/index.ts
import { redirect } from "react-router-dom";
export {
  Await,
  defer,
  makeAction,
  makeLoader,
  redirect,
  typesafeBrowserRouter,
  useActionData,
  useLoaderData,
  useRouteLoaderData
};
